
import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { SkuProduct } from "../model/domain/propertyModel/SkuProduct";
import { IProductData } from "../product/model/domain/IProductData";
import { IProductRestService } from "./products-rest";
import { IAttributeValue } from "../product/model/domain/IAttributeValue";
import { Price } from "../model/domain/pricing/price";
import { IPropertyInfo, IPropertyKeyValue } from "../product/model/domain/property-key-value";
import { envConfig } from "@env/env-config";
import { ProductDescObj } from "../model/dto/ProductDescObj";
import is from "@core/comparators/is";
import { ParameterType } from "@core/data-access/abstract-accessor.service";

type ResponseType<T> = angular.IPromise<IResponse<T>>;

export class ProductRestService extends AbstractAccessorService<IProductData> implements IProductRestService {
    public readonly $name: string = "productV2RestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IProductData>) {
        super();
    }

    /**
     * 根据id获取单个对象
     * @param {(number | string)} id
     * @returns 
     */
    public getOne(id: number | string, versionedProductAttributeId?: number): angular.IPromise<IResponse<IProductData>> {
        return this.$accessor<IProductData, any, string>(this.$name, "getOne", { "parameter": { "id": id, versionedProductAttributeId: versionedProductAttributeId } });
    }

    /**
     * @description 通过propertyModelId创建SKU产品
     * @param configurableProductId 
     * @param propertyModelId 
     */
    public creatSku(configurableProductId: number, propertyModelId: number): angular.IPromise<IResponse<SkuProduct>> {
        return this.$accessor<SkuProduct, { configurableProductId: number, propertyModelId: number }, string>(this.$name, "creatSku", { parameter: { configurableProductId: configurableProductId, propertyModelId: propertyModelId } })
    }

    /**
     * @description 检查是否是内部产品
     */
    public isInternal(pid: number): angular.IPromise<IResponse<boolean>> {
        return this.$accessor(this.$name, "isInternal", {
            parameter: { pid: pid }
        })
    }

    /**
     * @description 获取产品销售价格
     * @param configurableProductId 
     * @param propertyModelId 
     */
    public pricing(pid: number, productAttribute: Array<IAttributeValue>, qty: number, currencyCode: string): angular.IPromise<IResponse<any>> {
        return this.$accessor(this.$name, "pricing", {
            parameter: {
                pid: pid
            },
            data: {
                product: {
                    attributeValues: productAttribute,
                    _id: pid
                },
                qty: qty,
                currencyCode: currencyCode,
            }
        })
    }
    /**
     * @description 获取产品销售价格--get方法
     * @param pid 
     * @param qty 
     * @param currencyCode
     * @param versionedAttributeId
     */
    public pricingGet(pid: number, qty: number, currencyCode: string, versionedAttributeId?: number): angular.IPromise<IResponse<Price>> {
        let _requestConfig = {
            parameter: {
                pid: pid,
                qty: qty,
                currencyCode: currencyCode,
                versionedAttributeId: versionedAttributeId
            }
        }

        return this.$accessor(this.$name, "pricingGet", _requestConfig)
    }

    /**
     * @description 获取产品最小购买数量-MOQ
     * @param pid 产品Id
     * @param versionedAttributeId 产品属性版本
     * versionedAttributeId?:number,propertyKey?:IPropertyKeyValue
     */
    public getMoq(pid: number, propertyInfo: IPropertyInfo): angular.IPromise<IResponse<any>> {
        let _requestConfig = {
            parameter: {
                pid: pid
            },
            data: propertyInfo
        }

        return this.$accessor(this.$name, "getMoq", _requestConfig)
    }

    /**
      * @description 获取产品描述信息 
      * @param productId
      * @param platformCode 店铺品台code
      * @param versionedAttributeId 
      * @param cmsConfigVersion
      * */
    public getDesc(productId: number, platformCode: string|undefined, versionedAttributeId: number | undefined, cmsConfigVersion: number | undefined): angular.IPromise<IResponse<ProductDescObj>> {
        let parameter: ParameterType = {
            productId:productId,
            platformCode:platformCode
        };
        if (!is.undefined(envConfig.APP_TAG)) {
            parameter.appTag = envConfig.APP_TAG;
        }
        if (!is.undefined(envConfig.APP_NAME)) {
            parameter.appName = (envConfig.APP_NAME).toUpperCase();
        }
        if (!is.undefined(versionedAttributeId)) {
            parameter.versionedAttributeId = versionedAttributeId;
        }
        if (!is.undefined(cmsConfigVersion)) {
            parameter.cmsConfigVersion = cmsConfigVersion;
        }

        return this.$accessor(this.$name, "getDesc", {
            parameter: parameter
        })
    }
}